export enum ExtensionStatus {
    RequestNotMade,
    Success,
    AlreadyRedeemed,
    Error
}
